<template>
  <div class="containerList">
    <el-button class="mwow-button-filled success add" @click="handleAdd">
      添加活动
    </el-button>
    <el-form class="mwow-wrap form" size="mini">
      <el-row>
        <el-col :span="8">
          <el-form-item label="活动名称:" prop="title">
            <el-input
              v-model="searchInfo.title"
              placeholder="请输入活动名称"
              clearable
              @change="handleSearch"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="活动类型:" prop="type">
            <el-select
              v-model="searchInfo.type"
              placeholder="请输入活动类型"
              clearable
              @clear="handleSearchType('')"
              filterable
              :filter-method="handleSearchType"
              @change="handleSearch"
              @visible-change="handleVisible"
            >
              <el-option
                v-for="item in activityTypeList"
                :key="item.type_id"
                :label="item.title"
                :value="item.type_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="创建时间:" prop="create_time">
            <common-date-range-selector
              v-model="searchInfo.create_time"
              start-placeholder="开始时间"
              range-separator="至"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              @change="handleSearch"
              :picker-options="effectiveDate"
            >
            </common-date-range-selector>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="活动状态:" prop="activity_status">
            <el-radio-group
              v-model="searchInfo.activity_status"
              @change="handleSearch"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">未开始</el-radio-button>
              <el-radio-button :label="2">进行中</el-radio-button>
              <el-radio-button :label="3">已结束</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="上下架状态:" prop="status">
            <el-radio-group v-model="searchInfo.status" @change="handleSearch">
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">进行中</el-radio-button>
              <el-radio-button :label="2">已结束</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="支付类型:" prop="is_pay">
            <el-radio-group v-model="searchInfo.is_pay" @change="handleSearch">
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">付费</el-radio-button>
              <el-radio-button :label="2">免费</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="活动名单数:" prop="viewList" class="item4">
            <div style="display: flex">
              <el-input
                v-model="searchInfo.effective_roster_start_num"
                @change="handleSearch('effective_roster_start_num')"
                placeholder="最低数量"
                type="number"
                clearable
                @input="handleInput('effective_roster_start_num', $event)"
              ></el-input>
              <span style="margin: 0 10px">至</span>
              <el-input
                v-model="searchInfo.effective_roster_end_num"
                @change="handleSearch('effective_roster_end_num')"
                placeholder="最高数量"
                type="number"
                clearable
                @input="handleInput('effective_roster_end_num', $event)"
              ></el-input>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <el-table
      size="mini"
      :data="tableData"
      stripe
      ref="tableRef"
      style="width: 100%"
      tooltip-effect="dark"
      class="table"
    >
      <el-table-column label="序号" type="index" width="50"> </el-table-column>
      <el-table-column label="活动名称" prop="title" width="100">
      </el-table-column>
      <el-table-column label="活动类型" prop="type" width="80">
        <template slot-scope="scope">
          {{ scope.row.type.title }}
        </template>
      </el-table-column>
      <el-table-column label="活动状态" prop="activity_status" width="70">
        <template slot-scope="scope">
          {{ handleActivityStatus(scope) }}
        </template>
      </el-table-column>
      <el-table-column label="活动开始时间" prop="start_time">
      </el-table-column>
      <el-table-column label="活动结束时间" prop="end_time"> </el-table-column>
      <el-table-column label="活动创建人" prop="staff" width="90">
        <template slot-scope="scope">
          {{ scope.row.staff.name }}
        </template>
      </el-table-column>
      <el-table-column label="活动创建时间" prop="create_time">
      </el-table-column>
      <el-table-column label="活动意向数" prop="roster_num" width="80">
      </el-table-column>
      <el-table-column
        label="活动名单数"
        prop="effective_roster_num"
        width="80"
      >
      </el-table-column>
      <el-table-column
        label="今日活动意向数"
        prop="today_roster_num"
        width="105"
      >
      </el-table-column>
      <el-table-column
        label="今日活动名单数"
        prop="today_effective_roster_num"
        width="105"
      >
      </el-table-column>
      <el-table-column label="支付类型" prop="is_pay" width="70">
        <template slot-scope="scope">
          {{ scope.row.is_pay === 1 ? "付费" : "免费" }}
        </template>
      </el-table-column>
      <el-table-column label="支付金额" prop="paid_amount" width="70">
        <template slot-scope="scope">
          {{ scope.row.is_pay === 1 ? scope.row.paid_amount : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="活动库存" prop="stock" width="70">
      </el-table-column>
      <el-table-column label="上下架" prop="status" width="60">
        <template slot-scope="scope">
          <el-switch
            class="mwow-switch"
            v-model="scope.row.status"
            @change="handleChangeStatus(scope)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="opreation" width="300">
        <template slot-scope="scope">
          <div class="btns">
            <el-button class="mwow-button success" @click="handleEdit(scope)">
              编辑
            </el-button>
            <el-button
              class="mwow-button primary"
              @click="toPromotionCode(scope)"
            >
              推广码 </el-button
            ><el-button class="mwow-button primary" @click="toViewList(scope)">
              意向名单
            </el-button>
            <el-button class="mwow-button info" @click="handleDel(scope)">
              删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>

<script>
import {
  getActivityListApi,
  delActivityApi,
  getActivitySelectTypeListApi,
  getActivitySelectListApi,
  editActivityStatusApi,
} from "@/api/marketActivity";
import { dateFormat } from "@/utils/timeFormat";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  name: "activityList",
  components: {
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {
        activity_status: -1,
        status: -1,
        is_pay: -1,
      },
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      tableData: [],
      activityTitleList: [],
      activityTypeList: [],
      // 过去时间不可选
      effectiveDate: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
    this.getActivietySelectTypeList();
    this.getActivitySelectList();
  },
  methods: {
    solveSearchInfo(option) {
      let params = { ...option };
      if (this.searchInfo.title) {
        params.title = this.searchInfo.title;
      }
      if (this.searchInfo.type) {
        params.type_id = this.searchInfo.type;
      }
      if (this.searchInfo.create_time) {
        params.time_type = 1;
        params.start_time =
          new Date(this.searchInfo.create_time[0] + " 00:00:01").getTime() /
          1000;
        params.end_time =
          new Date(this.searchInfo.create_time[1] + " 23:59:59").getTime() /
          1000;
      }
      if (this.searchInfo.effective_roster_start_num) {
        if (String(this.searchInfo.effective_roster_start_num).includes(".")) {
          this.$message({
            message: "活动名单数必须为整数",
            type: "error",
          });
          return false;
        }
        if (this.searchInfo.effective_roster_start_num < 0) {
          this.$message({
            message: "活动名单数必须大于或等于0",
            type: "error",
          });
          return false;
        }
        params.effective_roster_start_num = Number(
          this.searchInfo.effective_roster_start_num
        );
      }
      if (this.searchInfo.effective_roster_end_num) {
        if (String(this.searchInfo.effective_roster_start_num).includes(".")) {
          this.$message({
            message: "活动名单数必须为整数",
            type: "error",
          });
          return false;
        }
        if (this.searchInfo.effective_roster_end_num < 0) {
          this.$message({
            message: "活动名单数必须大于或等于0",
            type: "error",
          });
          return false;
        }
        params.effective_roster_end_num = Number(
          this.searchInfo.effective_roster_end_num
        );
      }
      if (this.searchInfo.activity_status > 0) {
        params.activity_status = Number(this.searchInfo.activity_status);
      }
      if (this.searchInfo.status > 0) {
        params.status = Number(this.searchInfo.status);
      }
      if (this.searchInfo.is_pay > 0) {
        params.is_pay = Number(this.searchInfo.is_pay);
      }
      return params;
    },
    getList(params) {
      let option = this.solveSearchInfo(params);
      getActivityListApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            item.create_time = item.create_time
              ? dateFormat("YYYY-mm-dd HH:MM:SS", item.create_time * 1000)
              : "-";
            item.start_time = item.start_time
              ? dateFormat("YYYY-mm-dd HH:MM:SS", item.start_time * 1000)
              : "-";
            item.end_time = item.end_time
              ? dateFormat("YYYY-mm-dd HH:MM:SS", item.end_time * 1000)
              : "-";
            item.paid_amount = item.paid_amount === "" ? "-" : item.paid_amount;
            item.status = item.status === 1 ? true : false;
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    handleSearch(v) {
      if (v === "effective_roster_start_num") {
        if (
          this.searchInfo.effective_roster_start_num &&
          this.searchInfo.effective_roster_end_num &&
          Number(this.searchInfo.effective_roster_start_num) >
            Number(this.searchInfo.effective_roster_end_num)
        ) {
          return this.$message({
            message: "最低数量不能大于最高数量",
            type: "error",
          });
        }
      }
      if (v === "effective_roster_end_num") {
        if (
          this.searchInfo.effective_roster_start_num &&
          this.searchInfo.effective_roster_end_num &&
          Number(this.searchInfo.effective_roster_start_num) >
            Number(this.searchInfo.effective_roster_end_num)
        ) {
          return this.$message({
            message: "最低数量不能大于最高数量",
            type: "error",
          });
        }
      }
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    // 新增
    handleAdd() {
      this.$router.push({
        name: "addActivity",
      });
    },
    // 编辑
    handleEdit(scope) {
      this.$router.push({
        name: "addActivity",
        query: {
          activity_id: scope.row.activity_id,
        },
      });
    },
    // 删除
    handleDel(scope) {
      this.$confirm("确定对该活动进行删除吗？", `"删除-${scope.row.title}"`, {
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "mwow-button-filled success",
        cancelButtonClass: "mwow-button-filled",
        iconClass: "mwow-icon-error",
      })
        .then(() => {
          if (scope.row.status || scope.row.activity_status !== 3) {
            this.$message({
              // message: "活动未下架无法进行删除操作",
              message: "活动结束且下架才能进行删除操作",
              type: "error",
            });
          } else {
            delActivityApi({ activity_id: scope.row.activity_id }).then(
              (res) => {
                if (res.error_code === 0) {
                  this.$message({
                    message: "删除成功",
                    type: "success",
                  });
                  this.getList({
                    page: this.page,
                    page_size: this.pageSize,
                  });
                } else {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }
              }
            );
          }
        })
        .catch(() => {});
    },
    // 活动名称列表
    getActivitySelectList(v) {
      getActivitySelectListApi({
        page: 1,
        page_size: 100,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.activityTitleList = res.data.list;
        }
      });
    },
    // 活动类型列表
    getActivietySelectTypeList(v) {
      getActivitySelectTypeListApi({
        page: 1,
        page_size: 100,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.activityTypeList = res.data.list;
        }
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    // 跳转推广码页面
    toPromotionCode(scope) {
      this.$router.push({
        name: "promotionCode",
        query: {
          activity_id: scope.row.activity_id,
        },
      });
    },
    // 跳转意向名单页面
    toViewList(scope) {
      this.$router.push({
        name: "viewList",
        query: {
          activity_id: scope.row.activity_id,
          is_pay: scope.row.is_pay,
        },
      });
    },
    // 模糊搜索 - 活动名称
    handleSearchTitle(v) {
      this.getActivitySelectList(v);
    },
    // 模糊搜索 - 活动类型
    handleSearchType(v) {
      this.getActivietySelectTypeList(v);
    },
    // 列表下拉
    handleVisible(v) {
      if (v) {
        this.getActivietySelectTypeList();
        this.getActivitySelectList();
      }
    },
    handleActivityStatus(scope) {
      if (scope.row.activity_status === 1) {
        return "未开始";
      }
      if (scope.row.activity_status === 2) {
        return "进行中";
      }
      if (scope.row.activity_status === 3) {
        return "已结束";
      }
    },
    handleChangeStatus(scope) {
      let status = scope.row.status === true ? 1 : 2;
      editActivityStatusApi({
        activity_id: scope.row.activity_id,
        status: status,
      }).then((res) => {
        if (res.error_code === 0) {
          this.$message({
            type: "success",
            message: "操作成功",
          });
        }
      });
    },
    handleInput(params, evt) {
      // 限制数量
      if (evt.length > 9) {
        if (params === "effective_roster_start_num") {
          this.searchInfo.effective_roster_start_num = Number(evt.slice(0, 9));
        }
        if (params === "effective_roster_end_num") {
          this.searchInfo.effective_roster_end_num = Number(evt.slice(0, 9));
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.containerList {
  background-color: #ffffff;
  border-radius: 4px;
}
/deep/.form {
  .el-form-item {
    display: flex;
    .el-form-item__label {
      min-width: 100px !important;
    }
    .el-form-item__content {
      width: 74%;
      div:nth-child(1) {
        width: 100%;
      }
    }
  }
}

.table {
  .btns {
    display: flex;
  }
}

.add {
  margin: 0 0 20px 10px;
}
</style>
